import { create } from 'zustand'

/**
 * Upgrade modal global state.
 *
 * Any component can call `useUpgradeStore().open()` to trigger the upgrade
 * modal without needing prop drilling. The modal itself is mounted once at
 * the AppLayout level and listens to this store.
 */
interface UpgradeStore {
  isOpen: boolean
  open: () => void
  close: () => void
}

export const useUpgradeStore = create<UpgradeStore>()((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}))
